import React, { useState } from 'react';
import { motion } from 'framer-motion';

const AboutHero = () => {
  const [imageError, setImageError] = useState(false);

  return (
    <section className="relative min-h-[45vh] flex items-center justify-center">
      {/* Background Image */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 bg-black/80 mix-blend-multiply z-10" />
        <img
          src="/about-us-hero.jpg"
          alt="Abstract hexagonal pattern"
          className="w-full h-full object-cover"
          onError={(e) => {
            console.error('Image failed to load:', e);
            setImageError(true);
          }}
          onLoad={() => {
            console.log('Image loaded successfully');
            setImageError(false);
          }}
          style={{ opacity: imageError ? 0 : 1 }}
        />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto text-center"
        >
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-4xl md:text-h1 font-display font-semibold text-white mb-6 leading-[1.2]"
          >
            About Us
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-lg md:text-xl text-gray-200 leading-[1.6]"
          >
            Born from the Vision of Expo City Dubai
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutHero;